/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './App.css';
import { useStateContext } from './contexts/ContextProvider';
import LoginPage from './components/LoginPage';
import Protected from './components/Protected';
import { Certified, CoreInventory, MaterialInventory, ShipmentHistory, FgInventory, ProductDetail, ProductReturn } from './pages';
import Dashboard from './pages/Dashboard';
import Inboundrma from './pages/Inboundrma';
import Failurecodes from './pages/Failurecodes';
import Summary from './pages/Summary';
import SKUSetup from './pages/ItemMaster';
import EbayShipping from './pages/EbayShipping';
import CorePutaway from './pages/CorePutaway';
import QCDetails from './pages/QCDetails';
import Cmob1QC from './pages/Cmob1QC';
import RAReturnReasons from './pages/RAReturnReasons';
// import TextViewPage from './pages/TextViewPage';
import FileUpload from './pages/FileUpload';
import SlaReturns from './pages/SlaReturns';
import BacklogTab from './pages/BacklogTab';
import BlanketRMA from './pages/BlanketRMA';
import ReceivingTrends from './pages/ReceivingTrends';
import TrendsCertified from './pages/TrendsCertified';
import TrendsEbay from './pages/TrendsEbay';
import RetailItemMaster from './pages/RetailItemMaster';
import TransferIntake from './pages/TransferIntake';
import ProductReturnSerial from './pages/PrSerial';
import UnauthorizeList from './pages/UnauthorizeList';

const App = () => {
  const { currentMode } = useStateContext();
  useEffect(() => {
    let timeoutId;
    const startTimer = () => {
      timeoutId = setTimeout(() => {
        if (JSON.parse(localStorage.getItem('loginID'))?.IsSuccess === true) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Your session has timed out due to inactivity!',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              localStorage.removeItem('loginID');
              document.querySelector('#naviagebtn').click();
            }
          });
        }
      }, 1800000);
    };

    const resetTimer = () => {
      clearTimeout(timeoutId);
      startTimer();
    };

    document.addEventListener('mousemove', resetTimer);
    document.addEventListener('keydown', resetTimer);

    startTimer();

    return () => {
      document.removeEventListener('mousemove', resetTimer);
      document.removeEventListener('keydown', resetTimer);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <HashRouter>
        <div>
          <div>
            <Routes basename="/inbound">
              <Route path="/" exact element={<LoginPage />} />
              {/* Activity Tabs */}
              <Route path="/Inbound RMA" exact element={<Protected Component={Inboundrma} />} />
              <Route path="/Daily Product Returns Activity" exact element={<Protected Component={ProductDetail} />} />
              <Route path="/Product Return Serial" exact element={<Protected Component={ProductReturnSerial} />} />
              <Route path="/RA Lookup" exact element={<Protected Component={ProductReturn} />} />
              <Route path="/SimpliCertified Production" exact element={<Protected Component={Certified} />} />
              <Route path="/QC Details" exact element={<Protected Component={QCDetails} />} />
              <Route path="/Failure Codes" exact element={<Protected Component={Failurecodes} />} />
              <Route path="/Outbound Shipment History" exact element={<Protected Component={ShipmentHistory} />} />
              <Route path="/Ebay Shipping History" exact element={<Protected Component={EbayShipping} />} />
              <Route path="/Core Putaway" exact element={<Protected Component={CorePutaway} />} />
              <Route path="/CMOB1 QC" exact element={<Protected Component={Cmob1QC} />} />
              <Route path="/RA Return Reasons" exact element={<Protected Component={RAReturnReasons} />} />
              <Route path="/Returns SLA" exact element={<Protected Component={SlaReturns} />} />
              <Route path="/Backlog RMA" exact element={<Protected Component={BacklogTab} />} />
              <Route path="/Blanket RMA" exact element={<Protected Component={BlanketRMA} />} />
              <Route path="/Transfer Intake" exact element={<Protected Component={TransferIntake} />} />
              <Route path="/UnAuthorized List" exact element={<Protected Component={UnauthorizeList} />} />
              {/* Inventory Tabs */}
              <Route path="/Core Inventory" exact element={<Protected Component={CoreInventory} />} />
              <Route path="/FG Inventory" exact element={<Protected Component={FgInventory} />} />
              <Route path="/Materials Inventory" exact element={<Protected Component={MaterialInventory} />} />
              {/* Analytics */}
              <Route path="/Receiving Trends" exact element={<Protected Component={ReceivingTrends} />} />
              <Route path="/Certified Trends" exact element={<Protected Component={TrendsCertified} />} />
              <Route path="/Ebay Trends" exact element={<Protected Component={TrendsEbay} />} />
              {/* Major Tabs */}
              <Route path="/Dashboard View" exact element={<Protected Component={Dashboard} />} />
              <Route path="/Summaries" exact element={<Protected Component={Summary} />} />
              <Route path="/Item Master" exact element={<Protected Component={SKUSetup} />} />
              <Route path="/Retail Item Master" exact element={<Protected Component={RetailItemMaster} />} />
              {/* <Route path="/Grade A Product" exact element={<Protected Component={GradeProduct} />} /> */}
              {/* <Route path="/Serial link" exact element={<Protected Component={TextViewPage} />} /> */}
              <Route path="/Upload Files" exact element={<Protected Component={FileUpload} />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </div>
      </HashRouter>
    </div>
  );
};

export default App;
